import API from "../api/manager";
import config from "../api/config";

const getProperty = () => {
  return API({
    method: "GET",
    url: config.urls.getProperty,
  });
};
const getRooms = (id) => {
  return API({
    method: "GET",
    url: config.urls.getRooms + "/" + id + "/rooms-v2",
  });
};
const getConfig = (id) => {
  return API({
    method: "GET",
    url: config.urls.getConfigById + "/" + id,
  });
};
const updateConfig = (data, propertyId) => {
  return API({
    method: "PUT",
    url: config.urls.updateConfig + `/${propertyId}`,
    data,
  });
};

// Whether the server answers at all (app/services/UserService.js getHealth).
// Rejects with { status, data } when it answers with an error, so callers can
// tell a refusal from no answer.
const getHealth = () => {
  return API(
    {
      method: "GET",
      url: `${config.urls.user}/hello`,
    },
    true,
    { keepStatus: true }
  );
};

// The terms and privacy policy the user agreed to (their latest agreement, or
// none) and the latest version (app/services/UserService.js): both answer a
// list of at most one.
const getPolicy = () => {
  return API({
    method: "GET",
    url: config.urls.userPolicy,
  });
};
const getPolicyLatest = () => {
  return API({
    method: "GET",
    url: config.urls.userPolicy + "/latest",
  });
};
// { policy_id, has_agreed, policy_version }
const createPolicy = (data) => {
  return API({
    method: "POST",
    url: config.urls.userPolicy,
    data,
  });
};

// The home's postal address, for owners (app/services/UserService.js). It isn't
// part of the home record, so getConfig leaves it out. GET answers
// { address: null } until one is saved; PUT replaces the whole address and
// answers { address }.
const getHomeAddress = (propertyId) => {
  return API({
    method: "GET",
    url: config.urls.getConfigById + `/${propertyId}/address`,
  });
};
const saveHomeAddress = (propertyId, address) => {
  return API({
    method: "PUT",
    url: config.urls.updateConfig + `/${propertyId}/address`,
    data: { address },
  });
};

//Door sensor api

const getDoorStatusForDay = (deviceId, dates) => {
  return API({
    method: "GET",
    url:
      config.urls.getDoorStatusForDay + `/bcddc2f0e665?requestDate=2023-10-27`,
  });
};

const getDoorStatusForMonth = (deviceId, dates) => {
  return API({
    method: "GET",
    url: `${config.urls.getDoorStatusForMonth}/${deviceId}?requestDate=${dates}`,
  });
};

const getDoorStatusForYear = (deviceId, dates) => {
  return API({
    method: "GET",
    url: `${config.urls.getDoorStatusForYear}/${deviceId}?requestDate=${dates}`,
  });
};

const getDeviceTypes = (id) => {
  return API({
    method: "GET",
    url: config.urls.getDeviceTypes + "/" + id + "/device/types",
  });
};
const stateUpdate = (data, propertyId) => {
  return API({
    method: "POST",
    url: config.urls.updateState + `/${propertyId}`,
    data,
  });
};
const getLastStatebydeviceId = (propertyId, deviceId) => {
  return API({
    method: "GET",
    url: config.urls.getLastState + `/${propertyId}/deviceId/${deviceId}`,
  });
};
const getLastStateByRoom = (propertyId, floor, room) => {
  return API({
    method: "GET",
    url:
      config.urls.getLastState + `/${propertyId}/floor/${floor}/room/${room}`,
  });
};
const getLastStateByFloorRoomId = (propertyId, floorId, roomId) => {
  return API({
    method: "GET",
    url:
      config.urls.getLastState +
      `/${propertyId}/floor-id/${floorId}/room-id/${roomId}`,
  });
};
const getLastStateByProperty = (propertyId) => {
  return API({
    method: "GET",
    url: config.urls.getLastState + `/${propertyId}`,
  });
};
const fav = (data, propertyId) => {
  return API({
    method: "PUT",
    url: config.urls.getDeviceTypes + `/${propertyId}` + "/favourite",
    data,
  });
};
const userFav = (data, propertyId) => {
  return API({
    method: "PUT",
    url: config.urls.getDeviceTypes + `/${propertyId}` + "/user-favourite",
    data,
  });
};
const updateDevice = (data, propertyId) => {
  return API({
    method: "PUT",
    url: config.urls.getDeviceTypes + `/${propertyId}` + "/appliance",
    data,
  });
};
const registerDevice = (data) => {
  return API({
    method: "POST",
    url: config.urls.registerDevice + "/register",
    data,
  });
};

const createProperty = (data) => {
  return API({
    method: "POST",
    url: config.urls.getConfigById,
    data,
  });
};

// Deletes a home; only the user who created it may (the API checks).
const deleteProperty = (propertyId) => {
  return API({
    method: "DELETE",
    url: config.urls.getConfigById + "/" + propertyId,
  });
};

const createFloor = (propertyId, data) => {
  return API({
    method: "POST",
    url: config.urls.getConfigById + "/" + propertyId + "/floor",
    data,
  });
};

const deleteFloor = (propertyId, data) => {
  return API({
    method: "DELETE",
    url: config.urls.getConfigById + "/" + propertyId + "/floor",
    data,
  });
};

const createRoom = (propertyId, data) => {
  return API({
    method: "POST",
    url: config.urls.getConfigById + "/" + propertyId + "/room",
    data,
  });
};

const deleteRoom = (propertyId, data) => {
  return API({
    method: "DELETE",
    url: config.urls.getConfigById + "/" + propertyId + "/room",
    data,
  });
};

const createDevice = (propertyId, data) => {
  return API({
    method: "POST",
    url: config.urls.getConfigById + "/" + propertyId + "/device",
    data,
  });
};

const deleteDevice = (propertyId, deviceId) => {
  return API({
    method: "DELETE",
    url: config.urls.deleteDevice + "/" + propertyId + "/remove/" + deviceId,
  });
};

const getTimeline = (deviceId, dates) => {
  return API({
    method: "GET",
    url: `${config.urls.getTimeline}/${deviceId}/?from=${dates[0]}&to=${dates[1]}`,
  });
};

// Saved versions of a device's settings, for "Recent changes to settings"
// ({ data: [{ time, device_settings | motor_config }] }).
const getActivitybyId = (propertyId, applianceId) => {
  return API({
    method: "GET",
    url: `${config.urls.activity}/getActivity/${propertyId}/${applianceId}`,
  });
};

// A device's e-warranty: model, duration, start_date, end_date, serviceEnabled.
const getWarranty = (deviceId) => {
  return API({
    method: "GET",
    url: `${config.urls.warranty}/${deviceId}`,
  });
};

// All on or all off for many devices in one request (POST control/{pid}/bulk,
// hashh-api-v2), as the app's power buttons do. state is "on" or "off";
// speeds ({ applianceId: 0-10 }) is the speed each fan switches on at. The API
// leaves out devices it can't switch this way and answers
// { state, sent, devices: [{ applianceId, ok, message }] }.
const bulkControl = (propertyId, state, applianceIds, speeds) => {
  const data = { state, applianceIds };
  if (speeds && Object.keys(speeds).length) data.speeds = speeds;
  return API({
    method: "POST",
    url: `${config.urls.updateState}/${propertyId}/bulk`,
    data,
  });
};

// A security alarm's history: the alerts it raised, newest first
// ({ time, info: { content } }), as the app's getSecurityLogs.
const getSecurityLogs = (deviceId, dates) => {
  return API({
    method: "GET",
    url: `${config.urls.notification}/device/${deviceId}`,
    params: { from_date: dates[0], to_date: dates[1] },
  });
};

const getKwhData = (deviceId) => {
  return API({
    method: "GET",
    url: `${config.urls.getKwhByMonth}/${deviceId}`,
  });
};

const getWattsLastOneHourData = (deviceId) => {
  return API({
    method: "GET",
    url: `${config.urls.getWattsByLastOneHour}/${deviceId}`,
  });
};

const getKwhWeekData = (deviceId) => {
  return API({
    method: "GET",
    url: `${config.urls.getKwhByWeek}/${deviceId}`,
  });
};

// The device with its saved settings, such as an energy meter's alarm limits.
const getDevice = (deviceId) => {
  return API({
    method: "GET",
    url: `${config.urls.registerDevice}/${deviceId}`,
  });
};

// Short-lived MQTT login for one meter's live readings: { mqtt_credentials:
// { username, password, allowed_topics } }. The broker lets it subscribe to
// those topics only, never publish.
const mqttCredentials = (applianceId, propertyId) => {
  return API({
    method: "POST",
    url: config.urls.mqttCredentials,
    data: { appliance_id: applianceId, propertyId },
  });
};

const getEnergyTelemetry = (deviceId) => {
  return API({
    method: "GET",
    url: `${config.urls.energyTelemetry}/${deviceId}`,
  });
};

const getEnergyGraph = (deviceId, period, from, to) => {
  return API({
    method: "GET",
    url: `${config.urls.energyHistoryRange}/${deviceId}?period=${period}&from=${from}&to=${to}`,
  });
};

// Like the mobile app, send rate=null to get the saved per-unit cost back.
const getEnergyMeterExpense = (deviceId, year, month, rate) => {
  const yearMonth = `${year}-${String(month).padStart(2, "0")}`;
  return API({
    method: "GET",
    url: `${config.urls.energyMeterExpense}/${deviceId}/${yearMonth}?rate=${encodeURIComponent(rate)}`,
  });
};

const getHIKCodes = (propertyId) => {
  return API({
    method: "GET",
    url: config.urls.getHIKCodes(propertyId),
  });
};

const getHIKAccessToken = (propertyId) => {
  return API({
    method: "GET",
    url: config.urls.getHIKAccessToken(propertyId),
  });
};

const addHIKDevice = (propertyId, postbody) => {
  return API({
    method: "POST",
    url: config.urls.addHIKDevice(propertyId),
    data: postbody,
  });
};

const deleteHIKDevice = (propertyId, deviceId) => {
  return API({
    method: "DELETE",
    url: config.urls.deleteHIKDevice(propertyId, deviceId),
  });
};

const getRemoteCategories = () => {
  return API({
    method: "GET",
    url: config.urls.getRemoteCategories(),
  });
};
const getRemoteBrands = (categoryId, searchText, from, count) => {
  return API({
    method: "GET",
    url: config.urls.getRemoteBrands(categoryId, searchText, from, count),
  });
};

const getRemotes = (categoryId, brandId) => {
  return API({
    method: "GET",
    url: config.urls.getRemotes(categoryId, brandId),
  });
};

const decodeRemote = (postbody) => {
  return API({
    method: "POST",
    url: config.urls.decodeRemote,
    data: postbody,
  });
};

const decodeRemoteById = (propertyId, remoteId) => {
  return API({
    method: "GET",
    url: config.urls.decodeRemoteById(propertyId, remoteId),
  });
};

const addRemoteToProperty = (propertyId, postbody) => {
  return API({
    method: "POST",
    url: config.urls.addRemote(propertyId),
    data: postbody,
  });
};

const getRemoteData = (propertyId, remoteId) => {
  return API({
    method: "GET",
    url: config.urls.getRemoteData(propertyId, remoteId),
  });
};

const deleteRemote = (propertyId, remoteId) => {
  return API({
    method: "DELETE",
    url: config.urls.deleteRemote(propertyId, remoteId),
  });
};

const renameRemote = (propertyId, postbody) => {
  return API({
    method: "PUT",
    url: config.urls.renameRemote(propertyId),
    data: postbody,
  });
};

const updateRemoteKey = (propertyId, remoteId, postbody) => {
  return API({
    method: "PUT",
    url: config.urls.updateRemoteKey(propertyId, remoteId),
    data: postbody,
  });
};

const updateFcmToken = (data, propertyId) => {
  return API({
    method: "POST",
    url: config.urls.user + `/fcmToken`,
    data,
  });
};

const deleteFcmToken = (data, propertyId) => {
  return API({
    method: "DELETE",
    url: config.urls.user + `/fcmToken`,
    data,
  });
};

const userSearch = (searchQuery) => {
  return API({
    method: "GET",
    url: `${config.urls.user}/list`,
    params: { search: searchQuery },
  });
};

const getUserName = () => {
  return API({
    method: "GET",
    url: `${config.urls.user}/username`
  })
}

const getSharedUsers = (propertyId) => {
  return API({
    method: "GET",
    url: `${config.urls.getProperty}/${propertyId}/shared`,
  });
};

// The signed-in user's own sharing record for the property: role, who shared
// it with them and whether they own it (the app's getSharedUsersbyGuest).
const getSharedUsersbyGuest = (propertyId) => {
  return API({
    method: "GET",
    url: `${config.urls.getProperty}/${propertyId}/shared/guest`,
  });
};

const inviteUser = (data, propertyId) => {
  return API({
    method: "POST",
    url: `${config.urls.getProperty}/${propertyId}/share`,
    data,
  });
};

const updateSharing = (data, propertyId) => {
  return API({
    method: "PUT",
    url: `${config.urls.getProperty}/${propertyId}/share`,
    data,
  });
};

const deleteSharing = (propertyId, permissionId) => {
  return API({
    method: "DELETE",
    url: `${config.urls.getProperty}/${propertyId}/share/${permissionId}`,
  });
};

// Run time of an appliance per hour, day or month for the given date
// ("YYYY-M-D", as the app sends it); returns [{ run_time, timebucket }].
const RUNTIME_URLS = { day: "runtimeForDay", month: "runtimeForMonth", year: "runtimeForYear" };
const getRuntime = (period, applianceId, requestDate) => {
  return API({
    method: "GET",
    url: `${config.urls[RUNTIME_URLS[period]]}/${applianceId}/${requestDate}`,
  });
};

// The new Automation system's switches (/automation; only the "admin" account
// may call these). Saving them can take a while.
const getAutomationSettings = () => {
  return API({
    method: "GET",
    url: `${config.urls.automation}/settings`,
  });
};

const updateAutomationSettings = (data) => {
  return API({
    method: "PUT",
    url: `${config.urls.automation}/settings`,
    data,
    timeout: 120000,
  });
};

// How the new engine's automations ran over the last `hours` hours (1–168):
// run counts by outcome and type, and the problems, overdue, paused and to-review lists.
const getAutomationSummary = (hours = 24) => {
  return API({
    method: "GET",
    url: `${config.urls.automation}/summary?hours=${hours}`,
    timeout: 60000,
  });
};

// Calls old apps still make to the old routine, scene and rule routes, per day.
const getLegacyRouteUsage = (days = 30) => {
  return API({
    method: "GET",
    url: `${config.urls.automation}/legacy-usage?days=${days}`,
  });
};

const getSubscription = () => {
  return API({
    method: "GET",
    url: `${config.urls.subscription}/subscription`,
  });
};



export const UserService = {
  getProperty,
  getConfig,
  updateConfig,
  getHomeAddress,
  saveHomeAddress,
  getPolicy,
  getPolicyLatest,
  createPolicy,
  getHealth,
  getRooms,
  getDeviceTypes,
  stateUpdate,
  getLastStatebydeviceId,
  getLastStateByRoom,
  getLastStateByFloorRoomId,
  getLastStateByProperty,
  fav,
  userFav,
  updateDevice,
  registerDevice,
  createProperty,
  deleteProperty,
  createFloor,
  deleteFloor,
  createRoom,
  deleteRoom,
  createDevice,
  getTimeline,
  getSecurityLogs,
  bulkControl,
  getActivitybyId,
  getWarranty,
  getKwhData,
  getWattsLastOneHourData,
  getKwhWeekData,
  getDevice,
  getEnergyTelemetry,
  mqttCredentials,
  getEnergyGraph,
  getEnergyMeterExpense,
  deleteDevice,
  getHIKCodes,
  getHIKAccessToken,
  addHIKDevice,
  deleteHIKDevice,
  getRemoteCategories,
  getRemoteBrands,
  getRemotes,
  decodeRemote,
  decodeRemoteById,
  addRemoteToProperty,
  getRemoteData,
  deleteRemote,
  renameRemote,
  updateRemoteKey,
  updateFcmToken,
  deleteFcmToken,
  userSearch,
  getSharedUsers,
  getSharedUsersbyGuest,
  inviteUser,
  updateSharing,
  deleteSharing,
  getDoorStatusForDay,
  getDoorStatusForYear,
  getDoorStatusForMonth,
  getUserName,
  getRuntime,
  getAutomationSettings,
  updateAutomationSettings,
  getAutomationSummary,
  getLegacyRouteUsage,
  getSubscription
};
